import { setLoading, setGlobalMessage } from '../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../api_exception';

const BASE_PATH = "VENDOR_MEETING_INVITES";

export const loadMeetingInvites = (rowsPerPage = null, page = null, clearExisting = true, resetFilters = false) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        let state = getState().VENDOR_MEETING_INVITES;

        let filters = [];

        if (!resetFilters) {
            if (state.company) {
                filters.push({ name: "company", values: [state.company] });
            }

            if (state.state) {
                filters.push({ name: "state", values: [state.state] });
            }

            if (state.city && Array.isArray(state.city) && state.city.length > 0) {
                filters.push({ name: "city", values: state.city });
            }

            if (state.workType && Array.isArray(state.workType) && state.workType.length > 0) {
                filters.push({ name: "workType", values: state.workType });
            }
        }

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1,
        }

        if (filters.length > 0) {
            apiData.filters = filters;
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        if (clearExisting) {
            dispatch(setMeetingsData([], 0, apiData.itemsCount, 0));
        }

        client.post('/vendor/meeting_invites', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.meetingInvites) {
                    dispatch(setMeetingsData(result.data.meetingInvites,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const loadMeetingInvite = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/vendor/meeting_invite/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.meetingInvite) {
                    dispatch(setMeetingInviteData(result.data.meetingInvite));
                    dispatch(viewMeetingInvite(true));
                } else {
                    dispatch(setMeetingInviteData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewMeetingInvite(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setMeetingInviteData(null));
            });
    }


export const onAttendingMeeting = (id, isAttending = false, remark = null) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        client.post(`/vendor/meeting_invite`, {
            id: id,
            isAttending: isAttending,
            remark: remark
        }).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(loadMeetingInvites());
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const SET_MEETING_INVITES_DATA = `${BASE_PATH}/SET_MEETING_INVITES_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const SET_MEETING_INVITE = `${BASE_PATH}/SET_MEETING_INVITE`;
export const VIEW_MEETING_INVITE = `${BASE_PATH}/VIEW_MEETING_INVITE`;
export const OPEN_CONFIRM_DIALOG = `${BASE_PATH}/OPEN_CONFIRM_DIALOG`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setMeetingsData = (meetingInvites, page, rowsPerPage, totalRows) => ({
    type: SET_MEETING_INVITES_DATA,
    meetingInvites,
    page,
    rowsPerPage,
    totalRows
});

export const viewMeetingInvite = (open) => ({
    type: VIEW_MEETING_INVITE,
    open
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const setMeetingInviteData = (data) => ({
    type: SET_MEETING_INVITE,
    data
});

export const openConfirmDialog = (open, selectedId) => ({
    type: OPEN_CONFIRM_DIALOG,
    open,
    selectedId
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    meetingInvites: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',

    viewMeetingInvite: false,
    meetingInviteData: null,

    selectedId: null,
    openConfirmDialog: false,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_MEETING_INVITES_DATA:
            newState = {
                ...state,
                meetingInvites: [...action.meetingInvites],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VIEW_MEETING_INVITE:
            return { ...state, viewMeetingInvite: action.open };
        case SET_MEETING_INVITE:
            return {
                ...state,
                meetingInviteData: action.data
            }
        case OPEN_CONFIRM_DIALOG:
            return {
                ...state,
                openConfirmDialog: action.open,
                selectedId: action.selectedId
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}